import JSBI from 'jsbi';

export const FEE_DIVISOR = JSBI.BigInt(10000); // From ref.finance/jumbo specs
